import { render, staticRenderFns } from "./AccountantExpenditure.vue?vue&type=template&id=3b158145&scoped=true&"
import script from "./AccountantExpenditure.vue?vue&type=script&lang=js&"
export * from "./AccountantExpenditure.vue?vue&type=script&lang=js&"
import style0 from "./AccountantExpenditure.vue?vue&type=style&index=0&id=3b158145&lang=scss&scoped=true&"
import style1 from "./AccountantExpenditure.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b158145",
  null
  
)

export default component.exports